var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.188,
    height: 13.431,
    viewBox: "0 0 19.188 13.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shuttle-van",
    "data-name": "Icon awesome-shuttle-van",
    d: "M18.854,7.606,14.822,2.768a1.439,1.439,0,0,0-1.105-.518H.959A.959.959,0,0,0,0,3.209v8.634a.959.959,0,0,0,.959.959h.959a2.878,2.878,0,0,0,5.756,0h3.837a2.878,2.878,0,0,0,5.756,0h.959a.959.959,0,0,0,.959-.959V8.527A1.441,1.441,0,0,0,18.854,7.606ZM1.919,7.047V4.169H4.8V7.047Zm2.878,7.2A1.439,1.439,0,1,1,6.236,12.8,1.439,1.439,0,0,1,4.8,14.242Zm4.8-7.2H6.716V4.169H9.594Zm4.8,7.2A1.439,1.439,0,1,1,15.83,12.8,1.439,1.439,0,0,1,14.391,14.242Zm-2.878-7.2V4.169h1.979l2.4,2.878Z",
    transform: "translate(0 -2.25)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.d50f65bb660248584f6405f8b5f39e89.svg";
export { ForwardRef as ReactComponent };